module.exports = __webpack_public_path__ + "img/10.39511bdd.png";